import React from "react";
import NoResults from "components/Events/Explore/Sources/Common/NoResults";

const Checklist = () => <NoResults type="checklist" />;

export default Checklist;
